import React from 'react';
import LinkWithClickHandler from '../link/link-with-click-handler';

const DisclaimerCheckbox = ({ submitError, checked, handleOptInChange, handleKeyDown, handleLinkClick }) => {
  return (
    <div className="flex gap-x-2">
      <input
        className={`mt-1 ${submitError ? 'border-error' : ''}`}
        type="checkbox"
        id="registration_disclaimer"
        name="opt_in_registeration"
        checked={checked}
        onChange={handleOptInChange}
        onKeyDown={handleKeyDown}
        tabIndex={-1}
      />
      <div className="rte body-3 [&_a]:body-3-bold">
        By signing up, I affirm that I am at least 13 years old (14 years old for residents of Quebec, Canada) and that
        I agree to the Thinx, Inc.{' '}
        <LinkWithClickHandler
          link="/pages/terms-of-use"
          onClick={(e) => handleLinkClick(e)}
          classNames="body-3"
          ariaLabel="Navigate to Terms Of Use page"
        >
          Terms of Use
        </LinkWithClickHandler>
        ,{' '}
        <LinkWithClickHandler
          link="/pages/privacy-policy"
          onClick={(e) => handleLinkClick(e)}
          classNames="body-3"
          ariaLabel="Navigate to Privacy Policy page"
        >
          Privacy Policy
        </LinkWithClickHandler>
        ,{' '}
        <LinkWithClickHandler
          link="/pages/privacy-policy#washington-consumer-health-data-privacy-policy"
          onClick={(e) => handleLinkClick(e)}
          classNames="body-3"
          ariaLabel="Navigate to Washington Health Data Rights info"
        >
          Washington Health Data Rights
        </LinkWithClickHandler>
        , and{' '}
        <LinkWithClickHandler
          link="/pages/privacy-policy#financial-incentives"
          onClick={(e) => handleLinkClick(e)}
          classNames="body-3"
          ariaLabel="Navigate to Financial Incentives Offered info"
        >
          Financial Incentives Offered
        </LinkWithClickHandler>
        .
      </div>
    </div>
  );
};

export default DisclaimerCheckbox;
